const chartId = "chart-11"
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';
const colors = require('../../../colors');
const data = require('./data');
const _groupBy = require('lodash/groupBy')
const _sortBy = require('lodash/sortBy')
const _each = require('lodash/each')

const geoidName = require('../../geoid-placename-crosswalk');

function geoid2name(geoid) {
  if (geoid) {
    let name = geoidName.find(x => x.GEOID == geoid);
    return name ? name.placeName : geoid;
  } else {
    return geoid;
  }
}

const sortedData = _sortBy(data, "pctBlack");

const groupedData = _groupBy(sortedData, function(d) {
  if (d.pctBlack >= 80) {
    return "blue"
  } else if (d.pctBlack >= 60) {
    return "green"
  } else if (d.pctBlack >= 40) {
    return "yellow"
  } else if (d.pctBlack >= 20) {
    return "orange"
  } else if (d.pctBlack < 20) {
    return "magenta"
  }
});

var labelNames = {
  "blue": "\u226580% black",
  "green": "60-80% black",
  "yellow": "40-60% black",
  "orange": "20-40% black",
  "magenta": "\u003C20% black"
}

let datasets = [];
let labels = [];
_each(groupedData, function(group, key) {
  const obj = {
    label: labelNames[key],
    data: [],
    backgroundColor: colors.secondary[key][80].rgba,
    borderColor: colors.secondary[key][60].rgba,
    borderWidth: 1,
    fill: false,
    lineTension: 0,
  }
  _each(group, function(row) {
    labels.push(row.pctBlack)
    obj.data.push({
      w: row.geoid,
      x: row.LE,
      y: row.pctBachPlus,
      z: row.pctBlack
    })
  })
  datasets.push(obj)
})
labels = [...new Set(labels)]

let ctx = document.getElementById(chartId).getContext('2d');
new Chart(ctx, {
  type: 'scatter',
  data: {
    labels: labels,
    datasets: datasets
  },
  options: {
    responsive: true,
    aspectRatio: window.innerWidth > 992 ? 16 / 9 : 1,
    onResize: function(chartObj) {
      chartObj.aspectRatio = window.innerWidth > 992 ? 16 / 9 : 1;
      chartObj.update()
    },
    tooltips: {
      callbacks: {
        title: function(tooltipItem, data) {
          let datasetIndex = tooltipItem[0].datasetIndex;
          let index = tooltipItem[0].index
          let dataset = data.datasets[datasetIndex];
          let item = dataset.data[index];
          return geoid2name(item.w);
        },
        label: function() {
          return false;
        },
        afterLabel: function(tooltipItem, data) {
          let datasetIndex = tooltipItem.datasetIndex;
          let index = tooltipItem.index
          let dataset = data.datasets[datasetIndex];
          let item = dataset.data[index];
          return ["Bachelor Degree: " + item.y+"%", "Life Expectancy: " + item.x + " years", "Percent Black: " + item.z + "%"];
        },
      }
    },
    scales: {
      xAxes: [{
        ticks: {
          beginAtZero: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Life Expectancy'
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: false,
          callback: function(value) {
            return value+"%";
          }
        },
        scaleLabel: {
          display: true,
          labelString: 'Percent with Bachelor\'s Degree'
        }
      }]
    }
  }
})